<template>
	<div class="report">
		<!--    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="工作量" name="first">
        <div class="container">
          <div class="flex">
            <div style="float: right;width:150px;">
              <el-select v-model="value1" placeholder="客服解决状态">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>EEE
              </el-select>
            </div>
            <div class="date_box" style="float: right;;margin-right:20px;">
              <el-date-picker v-model="value1" type="date" placeholder="选择日期" class="date" ></el-date-picker>
            </div>
            <div class="clear"></div>
          </div>
          <div class="table_box">
            <el-table :data="tableData" style="width: 100%" :default-sort = "{prop: 'date', order: 'descending'}">
              <el-table-column prop="id"         label="会话ID" sortable width="180"></el-table-column>
              <el-table-column prop="enter_time" label="访客进入时间"  sortable width="180"></el-table-column>
              <el-table-column prop="customer"   label="接待客服">                          </el-table-column>
              <el-table-column prop="ename"      label="用户名"  >                          </el-table-column>
              <el-table-column prop="start_time" label="会话开始时间"  sortable>            </el-table-column>
              <el-table-column prop="end_time"   label="会话结束时间"  sortable>            </el-table-column>
              <el-table-column prop="sort"       label="咨询分类" >                         </el-table-column>
              <el-table-column prop="session"    label="会话终止方">                        </el-table-column>
              <el-table-column prop="channel"    label="来源渠道">                          </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <el-pagination
              :page-size="100" background
              layout="total, prev, pager, next"
              :total="2">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="工作质量" name="second">
        <div class="container">
          <div class="flex">
            <div style="float: right;width:150px;">
              <el-select v-model="value1" placeholder="客服解决状态">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="date_box" style="float: right;;margin-right:20px;">
              <el-date-picker v-model="value1" type="date" placeholder="选择日期" class="date" ></el-date-picker>
            </div>
            <div class="clear"></div>
          </div>
          <div class="table_box">
            <el-table :data="tableData" style="width: 100%" :default-sort = "{prop: 'date', order: 'descending'}">
              <el-table-column prop="id"         label="会话ID" sortable width="180"></el-table-column>
              <el-table-column prop="enter_time" label="访客进入时间"  sortable width="180"></el-table-column>
              <el-table-column prop="customer"   label="接待客服">                          </el-table-column>
              <el-table-column prop="ename"      label="用户名"  >                          </el-table-column>
              <el-table-column prop="start_time" label="会话开始时间"  sortable>            </el-table-column>
              <el-table-column prop="end_time"   label="会话结束时间"  sortable>            </el-table-column>
              <el-table-column prop="sort"       label="咨询分类" >                         </el-table-column>
              <el-table-column prop="session"    label="会话终止方">                        </el-table-column>
              <el-table-column prop="channel"    label="来源渠道">                          </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <el-pagination
              :page-size="100" background
              layout="total, prev, pager, next"
              :total="2">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="质检报表" name="third">

      </el-tab-pane>
      <el-tab-pane label="考勤报表" name="fourth">

      </el-tab-pane>
      <el-tab-pane label="服务绩效" name="fourth">

      </el-tab-pane>
      <el-tab-pane label="订单绩效" name="fourth">

      </el-tab-pane>
		</el-tabs>-->
		<div class="box">
			<div class="list" v-for="(item,index) in list">
				<div
					:class="item.class"
					@mouseenter="enter(index)"
					@mouseleave="leave(index)"
					@click="tap(index,list)"
				>
					{{item.text}}
					<i v-if="item.istrue" class="el-icon-warning"></i>
				</div>
				<div class="line"></div>
			</div>
			<div :class="class1">
				<p>
					<span>接入会话量</span>接入的会话量，包含访客来访和主动发起会话两种情况
				</p>
				<p>
					<span>未回复会话量</span> 有访客咨询，但客服未回复即离开的会话数量
				</p>
				<p>
					<span>未回复率</span> 未回复会话数和接入会话数的比值
				</p>
				<p>
					<span>转接量</span> 转出会话的数量，转出的会话不计入接入会话数中
				</p>
				<p>
					<span>有效会话量</span>接入会话量减去无效会话量
				</p>
				<p>
					<span>无效会话量</span>咨询分类为“无效会话”的会话量
				</p>
				<p>
					<span>主动发起会话量</span> 从历史消息、留言中主动发起会话的数量
				</p>
				<p>
					<span>留言处理量</span>经过处理的留言数量
				</p>
				<p>
					<span>登录总时长</span> 所选时段内客服登录的累计时长
				</p>
				<p>
					<span>在线总时长</span> 所选时段内客服在线状态的累计时长
				</p>
				<p>
					<span>在线时长占比</span>在线总时长与登录总时长的比值
				</p>
				<p>
					<span>管理端在线时长</span> 坐席管理员后台登录的累计时长
				</p>
				<p>
					<span>挂起总时长</span> 所选时间段内客服挂起状态的累计时长
				</p>
				<p>
					<span>挂起时长占比</span>挂起总时长与登录总时长的比值
				</p>
				<p>
					<span>小休总时长</span> 所选时间段内客服小休状态的累计时长
				</p>
				<p>
					<span>小休时长占比</span> 小休总时长与登录总时长的比值
				</p>
			</div>
			<div :class="class2">
				<p>
					<span>平均首次响应时间</span>访客首条询问和客服首次回复时间间隔的平均值
				</p>
				<p>
					<span>平均响应时间</span>所有访客询问和客服对应回复时间间隔的平均值
				</p>
				<p>
					<span>30s应答率</span>响应时间在30秒以内的回合数占比
				</p>
				<p>
					<span>平均会话时长</span>访客进入会话开始到结束时间间隔的平均值
				</p>
				<p>
					<span>参评率</span>有评价结果的会话和总会话数的比值，其中转接会话只算1次，受数据统计开关影响
				</p>
				<p>
					<span>邀评数</span>发出过邀评的会话数，包含客服发出的和系统发出的
				</p>
				<p>
					<span>邀评率</span>邀评数和总会话数的比值，其中转接会话只算1次
				</p>
				<p>
					<span>相对满意度</span>评价为满意的会话数和有评价结果的会话数的比值，受数据统计开关影响
				</p>
				<p>
					<span>答问比</span> 客服发出消息与访客发出消息的比值
				</p>
				<p>
					<span>撤回消息数</span>客服撤回的消息数
				</p>
				<p>
					<span>一次性解决率</span>统计周期内，访客未二次来访的会话与总会话数的比值（次日更新），受数据统计开关影响
				</p>
				<p>
					<span>用户解决率</span>用户选择状态为“已解决”的会话量与有解决状态的会话数的比值
				</p>
			</div>
			<div :class="class3">
				<p>
					<span>首次登录时间</span>账号首次处于“登录”状态的时间，以自然日为维度
				</p>
				<p>
					<span>首次在线时间</span>账号首次处于“在线”状态的时间，以自然日为维度
				</p>
				<p>
					<span>小休次数</span>账号切换到小休状态的次数，以自然日为维度
				</p>
				<p>
					<span>最后挂起时间</span>账号最后切换为“挂起”状态的时间，以自然日为维度
				</p>
				<p>
					<span>最后登出时间</span>账号最后登出七鱼系统的时间，以自然日为维度
				</p>
				<p>
					<span>坐席利用率</span>账号在线接待总时长与登录总时长的比值
				</p>
				<p>
					<span>跨天数据</span>前一自然日最后的状态会自动延续到后一自然日
				</p>
			</div>
		</div>

		<div class="list-div">
			<div class="list-option" v-if="ishow==0?true:false">
				<div class="flex">
					<div style="float: right;width:150px; margin-left:10px">
						<el-button
							class="add"
							type="primary"
							:loading="workLoadLoading"
							@click="export1()"
						>{{workLoadLoading?'正在处理数据...':'导出当前数据'}}</el-button>
					</div>
					<div style="float: right;width:150px;">
						<!--  -->
						<el-select placeholder="客服" v-model="UserId" @change="getList">
							<el-option v-for="item in option3" :key="item.id" :label="item.nickName" :value="item.id"></el-option>
						</el-select>
					</div>
					<div class="date_box" style="float: right;;margin-right:20px;">
						<!-- @input="List(1,10)" -->
						<el-date-picker
							@change="getList"
							v-model="datatime"
							type="datetimerange"
							:picker-options="pickerOptions"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd HH:mm:ss"
						></el-date-picker>
					</div>
					<div class="clear"></div>
				</div>
				<!-- style="width:1100px" -->
				<div style="padding-right:15px" class>
					<el-table :data="tableData" :default-sort="{prop: 'date', order: 'descending'}"   v-loading="gongzuoliang">
						<el-table-column prop="nickname" label="昵称" width="130"></el-table-column>
						<el-table-column prop="account" label="账号" width="130"></el-table-column>
						<!-- <el-table-column prop="loginTime" label="登录时长" width="130">
							<template slot-scope="scope">{{secondToDates(scope.row.loginTime)}}</template>
						</el-table-column>-->
						<el-table-column prop="receptionCount" label="接待量" width="100">
							<template slot-scope="scope">{{scope.row.receptionCount==0?"--":scope.row.receptionCount}}</template>
						</el-table-column>
						<el-table-column prop="messageCount" label="会话量" width="100">
							<template slot-scope="scope">{{scope.row.messageCount==0?"--":scope.row.messageCount}}</template>
						</el-table-column>
						<el-table-column prop="responseQuantity" label="30S应答会话量" width="100">
							<template
								slot-scope="scope"
							>{{scope.row.responseQuantity==0?"--":scope.row.responseQuantity}}</template>
						</el-table-column>
						<el-table-column label="接待转接量">
							<template slot-scope="scope">{{scope.row.transferVolume==0?"--":scope.row.transferVolume}}</template>
						</el-table-column>
						<el-table-column label="留言量">
							<template slot-scope="scope">{{scope.row.messageVolume==0?"--":scope.row.messageVolume}}</template>
						</el-table-column>
						<el-table-column label="留言回复量">
							<template
								slot-scope="scope"
							>{{scope.row.messageReplyQuantity==0?"--":scope.row.messageReplyQuantity}}</template>
						</el-table-column>
						<el-table-column label="会话答问率">
							<template slot-scope="scope">{{getRatio(scope.row.qaRatio)}}</template>
						</el-table-column>
						<el-table-column label="30S会话应答率">
							<template slot-scope="scope">{{getRatio(scope.row.responseRatio)}}</template>
						</el-table-column>
						<el-table-column label="接待转接率">
							<template slot-scope="scope">{{getRatio(scope.row.transferRatio)}}</template>
						</el-table-column>
						<el-table-column label="留言回复率">
							<template slot-scope="scope">{{getRatio(scope.row.messageResponseRatio)}}</template>
						</el-table-column>
						<el-table-column label="人员利用率">
							<template slot-scope="scope">{{getRatio(scope.row.personnelUtilizationRatio)}}</template>
						</el-table-column>
						<el-table-column label="满意度评价率">
							<template slot-scope="scope">{{getRatio(scope.row.evaluationRatio)}}</template>
						</el-table-column>
						<el-table-column label="相对满意率">
							<template slot-scope="scope">{{getRatio(scope.row.relativelySatisfiedRatio)}}</template>
						</el-table-column>
						<el-table-column label="平均会话响应时长">
							<template slot-scope="scope">{{secondToDates(scope.row.avgResponse)}}</template>
						</el-table-column>
						<el-table-column label="平均会话首响时长">
							<template slot-scope="scope">{{secondToDates(scope.row.avgFirstResponse)}}</template>
						</el-table-column>
						<el-table-column label="平均会话时长">
							<template slot-scope="scope">{{secondToDates(scope.row.avgSessionResponse)}}</template>
						</el-table-column>
						<el-table-column label="平均接入排队时长">
							<template slot-scope="scope">{{secondToDates(scope.row.avgAwaitTime)}}</template>
						</el-table-column>
						<el-table-column label="最长排队时长">
							<template slot-scope="scope">{{secondToDates(scope.row.maxAwaitTime)}}</template>
						</el-table-column>
						<!-- <el-table-column prop="no_Reply_session" label="未回复会话量" width="100">
							<template
								slot-scope="scope"
							>{{scope.row.no_Reply_session==0?"--":scope.row.no_Reply_session}}</template>
						</el-table-column>
						<el-table-column prop="amount_of_session" label="接入会话量">
							<template
								slot-scope="scope"
							>{{scope.row.amount_of_session==0?"--":scope.row.amount_of_session}}</template>
						</el-table-column>
						<el-table-column prop="accessChat_EndPeople" label="转接率 ">
							<template slot-scope="scope">{{getRatio(scope.row.accessChat_EndPeople)}}</template>
						</el-table-column>
						<el-table-column prop="message_rate" label="留言率 ">
							<template slot-scope="scope">{{getRatio(scope.row.message_rate)}}</template>
						</el-table-column>
						<el-table-column prop="answeredquestionsthan" label="答问比">
							<template slot-scope="scope">{{getRatio(scope.row.answeredquestionsthan)}}</template>
						</el-table-column>
						<el-table-column prop="canPingLv" label="参评率">
							<template slot-scope="scope">{{getRatio(scope.row.canPingLv)}}</template>
						</el-table-column>
						<el-table-column prop="satisfactionRate" label="相对满意度">
							<template slot-scope="scope">{{getRatio(scope.row.satisfactionRate)}}</template>
						</el-table-column>
						<el-table-column prop="personnelUtilization" label="人员利用率">
							<template slot-scope="scope">{{getRatio(scope.row.personnelUtilization)}}</template>
						</el-table-column>
						<el-table-column prop="avgResponseTime" label="平均响应时长" width="150">
							<template slot-scope="scope">{{secondToDates(scope.row.avgResponseTime)}}</template>
						</el-table-column>
						<el-table-column prop="moveInTime" label="就绪时长" width="130">
							<template slot-scope="scope">{{secondToDates(scope.row.moveInTime)}}</template>
						</el-table-column>
						<el-table-column prop="moveInTimeRatio" label="就绪占比">
							<template slot-scope="scope">{{getRatio(scope.row.moveInTimeRatio)}}</template>
						</el-table-column>
						<el-table-column prop="moveOutTime" label="未就绪时长" width="130">
							<template slot-scope="scope">{{secondToDates(scope.row.moveOutTime)}}</template>
						</el-table-column>
						<el-table-column prop="moveOutTimeRatio" label="未就绪占比">
							<template slot-scope="scope">{{getRatio(scope.row.moveOutTimeRatio)}}</template>
						</el-table-column>
						<el-table-column prop="hangUp" label="挂起时长" width="130">
							<template slot-scope="scope">{{secondToDates(scope.row.hangUp)}}</template>
						</el-table-column>
						<el-table-column prop="HangUpRatio" label="挂起占比">
							<template slot-scope="scope">{{getRatio(scope.row.HangUpRatio)}}</template>
						</el-table-column>
						<el-table-column prop="restTime" label="小休时长" width="130">
							<template slot-scope="scope">{{secondToDates(scope.row.restTime)}}</template>
						</el-table-column>
						<el-table-column prop="restTimeRatio" label="小休占比 ">
							<template slot-scope="scope">{{getRatio(scope.row.restTimeRatio)}}</template>
						</el-table-column>
						<el-table-column prop="cultivate" label="培训时长" width="130">
							<template slot-scope="scope">{{secondToDates(scope.row.cultivate)}}</template>
						</el-table-column>
						<el-table-column prop="cultivateRatio" label="培训占比">
							<template slot-scope="scope">{{getRatio(scope.row.cultivateRatio)}}</template>
						</el-table-column>
						<el-table-column prop="haveMeals" label="用餐时长">
							<template slot-scope="scope">{{secondToDates(scope.row.haveMeals)}}</template>
						</el-table-column>
						<el-table-column prop="haveMealsRatio" label="用餐占比 ">
							<template slot-scope="scope">{{getRatio(scope.row.haveMealsRatio)}}</template>
						</el-table-column>
						<el-table-column prop="firstOnlineTime" label="首次在线时间" width="150">
							<template slot-scope="scope">{{getFormatTime(scope.row.firstOnlineTime)}}</template>
						</el-table-column>
						<el-table-column prop="logoutTime" label="登出时长 ">
							<template slot-scope="scope">{{getFormatTime(scope.row.logoutTime)}}</template>
						</el-table-column>-->
					</el-table>
				</div>
				<div class="pagination">
					<!-- @current-change="List"			 -->
					<el-pagination
						@current-change="currentIndex"
						:page-size="pagination.pageSize"
						background
						layout="total, prev, pager, next"
						:total="pagination.total"
					></el-pagination>
				</div>
			</div>
			<div class="list-option" v-if="ishow==1?true:false">
				<AttendanceReport></AttendanceReport>
			</div>
			<div class="list-option" v-if="ishow==2?true:false">3</div>
			<div class="list-option" v-if="ishow==3?true:false">4</div>
			<div class="list-option" v-if="ishow==4?true:false">5</div>
		</div>
	</div>
</template>

<script>
import { DateTime } from '@/utils/common'
import { secondToDate, FormatTimes, formatDuring } from '@/utils/FormatTime.js'
import AttendanceReport from '../reportForm/attendanceReport'
export default {
	name: 'report',
	props: [],
	data() {
		return {
			option3: [],
			datatime: [],
			total: 2,
			ishow2: 7,
			ishow: 0,
			class1: 'flex-dialog',
			class2: 'flex-dialog flex-dialog2',
			class3: 'flex-dialog flex-dialog3',
			class4: 'flex-dialog flex-dialog4',
			list: [
				{
					class: 'option on',
					istrue: false,
					text: '工作量'
				},
				{
					class: 'option',
					istrue: false,
					text: '考勤报表'
				}
			],
			activeName: 'first',
			value: '',
			UserId: 0,
			options: [
				{
					value: '选项1',
					label: '所有客服组'
				},
				{
					value: '选项2',
					label: '所有客服组'
				}
			],
			tableData: [],
			pickerOptions: {
				disabledDate(date) {
					return date.getTime() >= Date.now()
				},
				shortcuts: [
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 7
							)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 30
							)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 90
							)
							picker.$emit('pick', [start, end])
						}
					}
				]
			},
			pagination: {
				pageIndex: 1,
				pageSize: 10,
				total: 10
			},
			workLoadLoading: false,
			gongzuoliang:false
		}
	},
	components: {
		AttendanceReport
	},
	watch: {},
	mounted: function() {
		this.show()
		let datetime = new DateTime()
		this.datatime.push(datetime.getYesterday() + ' 00:00:00')
		this.datatime.push(datetime.getYesterday() + ' 23:59:59')
		this.getList()
	},
	methods: {
		p(s) {
			return s < 10 ? '0' + s : s
		},
		getList() {
			let vm = this
			var userRequestVMLi = {
				UserId: vm.UserId,
				pagination: vm.pagination
			}
			if (vm.datatime.length > 0) {
				userRequestVMLi.StartTime = vm.datatime[0]
				userRequestVMLi.EndTime = vm.datatime[1]
			} else {
				vm.$message.error('请选择时间')
				return
			}
				vm.gongzuoliang=true
			vm.axios
				.post('UserReportForm/WorkLoad', userRequestVMLi, {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function({ data }) {
					console.debug(data)
					vm.tableData = data.data.list
					vm.pagination = data.data.pagination
							vm.gongzuoliang=false
				})
		},
		currentIndex(e) {
			this.pagination.pageIndex = e
			this.getList()
		},
		// //表格数据
		// List(pageIndex, pageSize) {
		// 	let $this = this
		// 	$this.tableData = []
		// 	$this.pageIndex = pageIndex
		// 	$this.pageSize = pageSize
		// 	var UserId = $this.value1
		// 	var StartTime = ''
		// 	var EndTime = ''
		// 	if ($this.datatime.length > 0) {
		// 		StartTime = $this.datatime[0]
		// 		EndTime = $this.datatime[1]
		// 	}
		// 	// if ($this.datatime != null && $this.datatime != '') {
		// 	// 	var d = new Date($this.datatime[0])
		// 	// 	var d1 = new Date($this.datatime[1])
		// 	// 	StartTime =
		// 	// 		d.getFullYear() +
		// 	// 		'-' +
		// 	// 		this.p(d.getMonth() + 1) +
		// 	// 		'-' +
		// 	// 		this.p(d.getDate())
		// 	// 	EndTime =
		// 	// 		d1.getFullYear() +
		// 	// 		'-' +
		// 	// 		this.p(d1.getMonth() + 1) +
		// 	// 		'-' +
		// 	// 		this.p(d1.getDate())
		// 	// }

		// 	var userRequestVMLi = {
		// 		UserId: UserId,
		// 		StartTime: StartTime,
		// 		EndTime: EndTime,
		// 		pages: pageIndex,
		// 		pageNum: pageSize
		// 	}

		// 	// var userRequestVM={
		// 	// UserId:UserId,
		// 	// StartTime:StartTime,
		// 	// EndTime:EndTime
		// 	// };
		// 	pageSize = 10
		// 	$this.axios
		// 		.post(
		// 			'UserReportForm/GetUserLoginReports_backstage',
		// 			userRequestVMLi,
		// 			{
		// 				headers: {
		// 					'Content-Type': 'application/json'
		// 				}
		// 			}
		// 		)
		// 		.then(function(data) {
		// 			console.log(data)

		// 			$this.tableData = data.data.data
		// 		})
		// 	$this.axios
		// 		.post('UserReportForm/User_Count', userRequestVMLi, {
		// 			headers: {
		// 				'Content-Type': 'application/json'
		// 			}
		// 		})
		// 		.then(function(data) {
		// 			$this.total = data.data
		// 		})
		// },
		//初始化数据
		show() {
			var $this = this
			$this.option3 = []
			this.axios
				.get('User/Select', {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
					// $this.option3 = data.data;
					var ss1 = {
						id: 0,
						nickName: '全部'
					}

					$this.option3.push(ss1)

					data.data.forEach(element => {
						var ss = {
							id: element.id,
							nickName: element.nickName
						}

						$this.option3.push(ss)
					})
					$this.value1 = $this.option3[0].id
				})
		},
		//导出数据
		export() {},
		tap(index, list) {
			console.log(index)
			console.log(list)
			for (let i = 0; i < list.length; i++) {
				list[i].class = 'option'
				list[i].istrue = false
				if (index == 0 || index == 1 || index == 3 || index == 5) {
					list[index].istrue = true
				}
				list[index].class = 'option on'
				this.ishow2 = index
			}
			this.ishow = index
		},
		enter(index) {
			if (index == 0) {
				if (this.list[index].istrue == true) {
					this.class1 = 'flex-dialog on'
				}
			}
			if (index == 1) {
				if (this.list[index].istrue == true) {
					this.class2 = 'flex-dialog flex-dialog2 on'
				}
			}
			if (index == 3) {
				if (this.list[index].istrue == true) {
					this.class3 = 'flex-dialog flex-dialog3 on'
				}
			}
			if (index == 5) {
				if (this.list[index].istrue == true) {
					this.class4 = 'flex-dialog flex-dialog4 on'
				}
			}
		},
		leave(index) {
			this.class1 = 'flex-dialog'
			this.class2 = 'flex-dialog flex-dialog2 '
			this.class3 = 'flex-dialog flex-dialog3'
			this.class4 = 'flex-dialog flex-dialog4'
		},
		//导出
		export1() {
			let vm = this
			var userRequestVMLi = {
				UserId: vm.UserId,
				pagination: vm.pagination
			}
			if (vm.datatime.length > 0) {
				userRequestVMLi.StartTime = vm.datatime[0]
				userRequestVMLi.EndTime = vm.datatime[1]
			} else {
				vm.$message.error('请选择时间')
				return
			}
			// var $this = this
			// var UserId = $this.value1
			// var StartTime = ''
			// var EndTime = ''
			// if ($this.datatime.length > 0) {
			// 	StartTime = $this.datatime[0]
			// 	EndTime = $this.datatime[1]
			// }
			// // if ($this.datatime != null && $this.datatime != '') {
			// // 	var d = new Date($this.datatime[0])
			// // 	var d1 = new Date($this.datatime[1])
			// // 	StartTime =
			// // 		d.getFullYear() +
			// // 		'-' +
			// // 		this.p(d.getMonth() + 1) +
			// // 		'-' +
			// // 		this.p(d.getDate())
			// // 	EndTime =
			// // 		d1.getFullYear() +
			// // 		'-' +
			// // 		this.p(d1.getMonth() + 1) +
			// // 		'-' +
			// // 		this.p(d1.getDate())
			// // }
			// var userRequestVMLi = {
			// 	UserId: UserId,
			// 	StartTime: StartTime,
			// 	EndTime: EndTime,
			// 	pages: 1,
			// 	pageNum: 10
			// }
			vm.workLoadLoading = true
		
			this.axios
				.post(
					'UserReportForm/GetUserLoginReports_backstage_Exprot',
					userRequestVMLi,
					{
						responseType: 'blob' //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
					}
				)
				.then(function(res) {
					vm.workLoadLoading = false
					let filename = `${userRequestVMLi.StartTime}_${userRequestVMLi.EndTime}_工作量报表.xls`
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = e => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
					}
				})
		},
		secondToDates(va) {
			if (va == null || va == undefined || va == '' || va == 0) {
				return '--'
			}
			return formatDuring(va)
		},
		getFormatTime(val) {
			if (val == null || val == undefined || val == '') {
				return '--'
			}
			return FormatTimes(val)
		},
		getRatio(val) {
			if (val == null || val == undefined || val == 0) {
				return '--'
			}
			if (val.toString().indexOf('%') > -1) {
				return val
			}
			return val + '%'
		}
	}
}
</script>

<style scoped>
.box {
	margin-top: 30px;
	position: relative;
}
.list {
	display: inline-block;
}
.list > div.option {
	display: inline-block;
	width: 100px;
	height: 50px;
	line-height: 50px;
	text-align: center;
	border-radius: 5px 5px 0 0;
	border: 1px solid #ddd;
	cursor: pointer;
	float: left;
	position: relative;
}
.list > div.option.on {
	color: #337eff;
	background-color: #fff;
	border-bottom: none;
}
div.line {
	display: inline-block;
	width: 10px;
	border-bottom: 1px solid #ddd;
	height: 50px;
	float: left;
	border-top: 1px solid transparent;
}
.flex-dialog {
	display: none;
	position: absolute;
	width: 500px;
	padding: 30px;
	min-height: 100px;
	background-color: #fff;
	top: 40px;
	left: 60px;
	box-shadow: 0 0 4px #ddd;
	z-index: 1000;
	text-align: left;
}
.flex-dialog2 {
	width: 800px;
	left: 150px;
}
.flex-dialog3 {
	left: 375px;
}
.flex-dialog4 {
	left: 600px;
	width: 650px;
}
.flex-dialog.on {
	display: block;
}
.flex-dialog p {
	white-space: nowrap;
	line-height: 28px;
	font-size: 14px;
	color: #333;
}
.flex-dialog p span {
	display: inline-block;
	width: 165px;
}

.system .flex {
	padding: 30px 0 10px 0;
}
.table_box {
	margin-top: 20px;
}
.pagination {
	text-align: right;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
}
.el-button {
	/* background-color: #fafafa; */
}

.table_box /deep/ .el-table__body-wrapper::-webkit-scrollbar {
	width: 10px;
	height: 10px;
}

.table_box /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
	background-color: #ddd;
	border-radius: 3px;
	cursor: pointer;
	/* border-radius: 10px;
	background-color: skyblue;
	cursor: pointer;
	background-image: -webkit-linear-gradient(
		45deg,
		rgba(255, 255, 255, 0.2) 25%,
		transparent 25%,
		transparent 50%,
		rgba(255, 255, 255, 0.2) 50%,
		rgba(255, 255, 255, 0.2) 75%,
		transparent 75%,
		transparent
	); */
}
.table_box /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
	background-color: #ccc;
}
</style>
<style>
.el-input__icon {
	line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/system/report.vue